
import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook, Twitter } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const Footer = () => {
  const year = new Date().getFullYear();
  const isMobile = useIsMobile();

  return (
    <footer className="bg-brand-green text-white">
      <div className="container-wide">
        <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-3 xs:gap-4 sm:gap-6 md:gap-8 py-6 xs:py-8 md:py-12">
          {/* Company Info */}
          <div>
            <div className={`flex ${isMobile ? 'justify-center' : 'justify-start'} items-center mb-4`}>
              <img
                src="/lovable-uploads/93ffdfe7-f204-4330-983d-c466933d9798.png"
                alt="Entretiens McBain Logo"
                className="h-12 mr-3" />
              
              <h2 className="font-display text-2xl font-semibold">
                Entretiens<span className="text-brand-sage-light">McBain</span>
              </h2>
            </div>
            {!isMobile &&
            <p className="text-gray-200 mb-6 max-w-xs">
                Compagnie locale spécialisée dans l'entretien paysager, offrant des services tant pour le résidentiel que commercial.
              </p>
            }
            <div className={`flex space-x-4 ${isMobile ? 'justify-center' : ''}`}>
              <a
                href="https://www.facebook.com/entretienMcBain"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-brand-sage-light transition-colors"
                aria-label="Facebook">
                
                <Facebook size={20} />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div className={isMobile ? 'text-center' : ''}>
            <h3 className="font-display text-xl font-medium mb-4">Liens Rapides</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-200 hover:text-white transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-200 hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              {isMobile ?
              <li>
                  <Link to="/contact" className="text-gray-200 hover:text-white transition-colors">
                    Contact
                  </Link>
                </li> :

              <>
                  <li>
                    <Link to="/gallery" className="text-gray-200 hover:text-white transition-colors">
                      Galerie
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" className="text-gray-200 hover:text-white transition-colors">
                      À Propos
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className="text-gray-200 hover:text-white transition-colors">
                      Contact
                    </Link>
                  </li>
                </>
              }
            </ul>
          </div>
          
          {/* Services - Simplified for mobile */}
          <div className={isMobile ? 'text-center' : ''}>
            <h3 className="font-display text-xl font-medium mb-4">Nos Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-gray-200 hover:text-white transition-colors">
                  Tonte de pelouse
                </Link>
              </li>
              {isMobile ?
              <li>
                  <Link to="/services" className="text-gray-200 hover:text-white transition-colors">
                    Déneigement
                  </Link>
                </li> :

              <>
                  <li>
                    <Link to="/services" className="text-gray-200 hover:text-white transition-colors">
                      Ouverture et fermeture de terrain
                    </Link>
                  </li>
                  <li>
                    <Link to="/services" className="text-gray-200 hover:text-white transition-colors">
                      Nettoyage de stationnement
                    </Link>
                  </li>
                  <li>
                    <Link to="/services" className="text-gray-200 hover:text-white transition-colors">
                      Déneigement
                    </Link>
                  </li>
                </>
              }
            </ul>
          </div>
          
          {/* Contact Info - Simplified for mobile */}
          <div className={isMobile ? 'text-center' : ''}>
            <h3 className="font-display text-xl font-medium mb-4">Contactez-nous</h3>
            <ul className={`space-y-4 ${isMobile ? 'flex flex-col items-center' : ''}`}>
              <li className={`flex items-center ${isMobile ? 'justify-center' : ''}`}>
                <Phone size={20} className="mr-3 flex-shrink-0" />
                <a href="tel:+14189289113" className="text-gray-200 hover:text-white transition-colors">
                  (418) 928-9113
                </a>
              </li>
              {!isMobile &&
              <>
                  <li className={`flex items-center ${isMobile ? 'justify-center' : ''}`}>
                    <Mail size={20} className="mr-3 flex-shrink-0" />
                    <a href="mailto:entretienmcbain@outlook.com" className="text-gray-200 hover:text-white transition-colors">
                      entretienmcbain@outlook.com
                    </a>
                  </li>
                  <li className={`flex items-start ${isMobile ? 'justify-center' : ''}`}>
                    <Facebook size={20} className="mr-3 mt-1 flex-shrink-0" />
                    <a href="https://www.facebook.com/entretienMcBain" className="text-gray-200 hover:text-white transition-colors">
                      Visitez notre page Facebook!
                    </a>
                  </li>
                </>
              }
              <li className={`flex items-center ${isMobile ? 'justify-center' : ''}`}>
                <MapPin size={20} className="mr-3 flex-shrink-0" />
                <span className="text-gray-200">
                  Québec, Canada
                </span>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-gray-700 py-6 text-center text-gray-300 text-sm">
          <p>&copy; {year} Entretiens McBain. Tous droits réservés.</p>
        </div>
      </div>
    </footer>);

};

export default Footer;